import { Button, Card } from '@iwoca/orion';

import IwocaLogo from './iwocaLogoWhite.svg';
import { buildQueryString } from '../../../utils/queryParams';
import { useSuspenseGetANTFormalOffers } from '../../hooks/useGetANTFormalOffers';
import { formatCurrency } from '../../utils/currency';
import { formatDate as formatDateUtil } from '../../utils/date';

const formatDate = (
  dateString: string | null = '',
  format: 'short' | 'long' = 'short',
) => {
  const date = dateString || new Date().toISOString();
  return formatDateUtil(date, format, { yearFormat: '2-digit' });
};

const getSoonestTimeout = (
  offers: { timeout?: string | null }[],
): string | null | undefined => {
  const offerWithSoonestTimeout = offers.reduce((prev, curr) =>
    (prev.timeout ?? '') < (curr.timeout ?? '') ? prev : curr,
  );
  return offerWithSoonestTimeout.timeout;
};

export const IsANTCard = () => {
  const { antFormalOffers } = useSuspenseGetANTFormalOffers();

  if (!antFormalOffers || antFormalOffers.length === 0) return null;

  if (antFormalOffers.length === 1) {
    const [offer] = antFormalOffers;
    const dateString = formatDate(offer.timeout, 'long');

    return (
      <Card className="mb-[var(--spacer-2xl)] !bg-ant-card font-[var(--text-weight-reg)]">
        <div className="grid grid-cols-[30px_auto] gap-l p-s">
          <img src={IwocaLogo} className="h-[30px] w-[30px]" alt="" />
          <div className="flex w-full items-center gap-l text-white">
            <div>
              <div className="mb-xs w-fit rounded-l bg-black/20 px-s py-xs text-s font-bold">
                Offer valid until {dateString}
              </div>
              <div className="mb-xs text-xl font-med">
                You're <span className="font-bold">approved</span> for a{' '}
                <span className="font-bold">
                  {formatCurrency(offer.available_cash!, 0)}
                </span>{' '}
                loan from iwoca.
              </div>
              <div className="mb-l text-m font-reg">
                Hit the button to access these funds today.
              </div>
              <a href={`/account/my-offers/${buildQueryString()}`}>
                <Button variant="secondary-alt">Access funds</Button>
              </a>
            </div>
          </div>
        </div>
      </Card>
    );
  }

  if (antFormalOffers.length > 1) {
    const timeout = getSoonestTimeout(antFormalOffers);
    const dateString = formatDate(timeout, 'long');

    return (
      <Card className="mb-[var(--spacer-2xl)] !bg-ant-card font-[var(--text-weight-reg)]">
        <div className="grid grid-cols-[30px_auto] gap-l p-s">
          <img src={IwocaLogo} className="h-[30px] w-[30px]" alt="" />
          <div className="flex w-full items-center gap-l text-white">
            <div>
              <div className="mb-xs text-xs font-reg">
                First offer valid until {dateString}
              </div>
              <div className="mb-s text-l font-bold">
                You've been <b>approved</b> for more than one loan with iwoca.
              </div>
              <div className="mb-l text-s font-reg">
                Hit the button to see your offers and choose the one that works
                best for you.
              </div>
              <a href="/account/my-offers/">
                <Button variant="secondary">See your offers</Button>
              </a>
            </div>
          </div>
        </div>
      </Card>
    );
  }

  return null;
};
